
import React from 'react';

const universities = [
  "MIT",
  "Stanford",
  "Purdue",
  "Arizona",
  "UCLA",
  "Cornell",
  "Columbia",
  "Johns Hopkins",
  "Wisconsin-Madison",
  "Minnesota",
  "IIT Bombay",
  "IIT Madras",
  "IIT Delhi",
  "Agrinnovate",
  "Arizona State University",
  "Max Planck Innovation",
  "Karlsruhe Institute of Technology",
  "RWTH Aachen University",
  "Durham University",
  "Newcastle University",
  "University of Pittsburgh",
  "Oxford University",
  "State University of New York",
  "University of Toronto",
  "University of Pennsylvania",
  "University of Maryland",
  "University of California, San Diego",
  "Council of Scientific & Industrial Research (CSIR)",
  "SRM Institute of Science & Technology (SRMIST)",
  "The University of Sydney",
  "Monash University",
  "The University of Melbourne",
  
];

const FeaturingSection: React.FC = () => {
  return (
    <div className="w-full bg-primary-100 py-8 sm:py-12 mt-8 sm:mt-12 overflow-x-hidden">
      <div className="text-center mb-6 sm:mb-10 px-2">
        <h2 className="text-xl sm:text-2xl font-medium font-space-grotesk uppercase tracking-widest">Featuring</h2>
        <p className="text-sm sm:text-base text-grayscale-1100 font-grotesk mt-2 break-words">
          Over 25,100 technologies and 34,400 inventors from leading research universities
        </p>
      </div>
      
      {/* Pill-shaped layout for universities */}
      <div className="max-w-4xl mx-auto px-2 sm:px-4">
        <div className="flex flex-wrap justify-center gap-2 sm:gap-3 md:gap-4">
          {universities.map((name, index) => (
            <span 
              key={index} 
              className="bg-white px-3 py-1.5 sm:px-4 sm:py-2 md:px-5 md:py-2.5 rounded-full text-xs sm:text-sm md:text-base font-medium text-grayscale-1200 shadow-sm hover:shadow-md transition-shadow border border-primary-200 whitespace-nowrap"
            >
              {name}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FeaturingSection;
